/** @jsxImportSource @emotion/react */
import { selectStyle } from './Select.styles';

export interface SelectOption {
  label: string;
  value: string;
}

export interface SelectProps {
  /** 미선택 시 표시 문구. 필터바의 Connection, Quality dimension 류. */
  placeholder?: string;
  options?: SelectOption[];
  value?: string;
  onChange?: (value: string) => void;
}

/** 드롭다운 선택. 대시보드 필터바 조건 선택에 활용. */
export function Select({ placeholder, options = [], value, onChange }: SelectProps) {
  return (
    <select
      css={selectStyle}
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
    >
      {placeholder !== undefined && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
